import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 0.5rem 0;
`;

export const Field = styled.div`
  min-width: ${props => props.minWidth || '200px'};
  flex: 0 0 ${props => props.minWidth || '200px'};
`;

export const Actions = styled.div`
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
  margin-top: 1.7rem;
`;
